<template>
    <div class="footer">
        <div class="container">
            <hr/>
            Copyright &copy; {{ new Date().getFullYear() }} <a href="https://artioscollege.org" target="_blank">Artios Christian College</a>
            <div class="pull-right">
                <a href="https://facebook.com/artioscollege" target="_blank"><i class="fa fa-facebook-square fa-2x"></i></a>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'page-footer',
        components: {},
        methods: {
        }
    }
</script>
